<template>
  <vc-calendar :attributes='attrs'>
  </vc-calendar>
</template>

<script>
export default {
    name: 'SimpleDate',
    data() {
        return {
        attrs: [
            {
            key: 'today',
            highlight: {
                backgroundColor: "#ff8080"
  },
            dates: new Date()
            }
        ],
        };
    },
    };
</script>


<style scoped lang="scss">
    .banana {
        color: green;
        background-color: green;
    }

</style>